import { DataLayer } from "@sazka/utils/data-layer";

type Position = "top" | "middle" | "bottom";

// DL4.60 Charity banner impression.
export function dataLayerCharityBannerImpression(bannerId: string, creative: string, position: Position) {
    console.log("dataLayerCharityBannerImpression", bannerId, creative, position);
    DataLayer.push({
        event: "action.impress.promos",
        action: {
            impress: {
                promos: [
                    {
                        id: bannerId,
                        name: "sazkaklub.charity.banner",
                        creative: creative,
                        position: `sazkaklub.charity.banner.${position}`,
                    },
                ],
            },
        },
    });
}

// DL4.61 Charity banner clicks (MORE INFO click).
export function dataLayerCharityBannerClickMoreInfo() {
    console.log("dataLayerCharityBannerClickMoreInfo");
    DataLayer.push({
        event: "action.clickMoreInfo.sazkaklub",
        action: {
            clickMoreInfo: {
                eventProperty1: "Charity banner",
            },
        },
    });
}

// DL4.61 Charity banner clicks (SPIN WHEEL click).
export function dataLayerCharityBannerClickSpinWheel(bannerId: string, creative: string, position: Position) {
    console.log("dataLayerCharityBannerClickSpinWheel", bannerId, creative, position);
    DataLayer.push({
        event: "action.show.promos",
        action: {
            show: {
                promos: [
                    {
                        id: bannerId,
                        name: "sazkaklub.charity.banner",
                        creative: creative,
                        position: `sazkaklub.charity.banner.${position}`,
                    },
                ],
            },
        },
    });
}
